export type BulkEventEditJobStatus = 'PREPARING' | 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';

export type BulkEventEditJobAction = 'internal-reject' | 'evidence-repackage';

export interface BulkEventEditJob {
  bulk_event_edit_job_id: number;
  bulk_event_edit_job_uuid: string;
  job_status: BulkEventEditJobStatus;
  s3_key: string;
  s3_object_version: string | null;
  action: BulkEventEditJobAction;
  jira_work_item: string;
  error_message: string | null;
  checkpoint_row_count: number | null;
  total_row_count: number | null;
  created_by: string;
  created_at: string;
  updated_at: string;
  started_at: string | null;
  completed_at: string | null;
}

export interface BulkEventEditJobsListResponse {
  jobs: BulkEventEditJob[];
  total_count: number;
}

export interface CreateBulkEventEditJobResponse {
  job_id: number;
  job_uuid: string;
  upload_url: string;
}

export const TERMINAL_STATUSES: BulkEventEditJobStatus[] = ['COMPLETED', 'FAILED'];
export const TRIGGERABLE_STATUSES: BulkEventEditJobStatus[] = ['PREPARING'];
export const FORCE_TRIGGERABLE_STATUSES: BulkEventEditJobStatus[] = ['PENDING', 'RUNNING'];
